import { Background, Container } from '@styles/helpers'
import React from 'react'
import { colors, typography } from '@styles/vars'
import Grid from '@blocks/Grid'
import styled from 'styled-components'
import Flex from './Flex'
import Button from './Button'
import { useConfigContext } from '@contexts/config'
import { route } from '@helpers'
import { Link } from 'react-router-dom'

function Footer({ column1 = <FooterDevelopedBy />, column2 = <FooterContacts />, column3 = <FooterSupport /> }: FooterProps) {
    return (
        <div>
            <FooterContainer>
                <Grid>
                    <Grid columns="3">
                        <div>{column1}</div>
                        <div>{column2}</div>
                        <div>{column3}</div>
                    </Grid>
                </Grid>
            </FooterContainer>
            <LinksContainer>
                <Flex gap="10px">
                    <FooterLink><a href={route("general:privacy")} target="_blank">Privacy Policy</a></FooterLink>
                    <FooterLink><a href={route("general:support")} target="_blank">Support</a></FooterLink>
                </Flex>
            </LinksContainer>
        </div>
        
    )
}

export default React.memo(Footer)

// COMPONENTS
export function FooterContacts() {
    const { support } = useConfigContext()

    return (
        <Grid gap="20px">
            <h3>Contacts</h3>
            <Button type="tertiary" to={`mailto:${support}`} element="a" scheme="reversed">{support}</Button>
        </Grid>
    )
}

export function FooterDevelopedBy() {
    return (
        <Grid gap="20px">
            <h3>Developed by</h3>
            <Button type="tertiary" to="https://ai-40.com" element="a" target="_blank" scheme="reversed">ai-40.com</Button>
        </Grid>
    )
}

export function FooterSupport() {
    return (
        <Grid gap="20px">
            <h3>Support</h3>
            <Button type="tertiary" to={route("general:support")} element="a" target="_blank" scheme="reversed">Contact</Button>
        </Grid>
    )
}

const FooterContainer = styled(Container)`
    background: ${colors.black};
    padding-top: 60px;
    padding-bottom: 60px;
    color: ${colors.white};

    h3 {
        margin-top: 0;
        color: ${colors.white};
        line-height: 1;
        margin-bottom: ${typography.margins.m};
    } 
`

const FooterLink = styled.small`
    a {
        color: ${colors.white};
        text-decoration: none;
    } 
`

const LinksContainer = styled(Container)`
    background: #1a1a1a;
    padding-top: 30px;
    padding-bottom: 30px;
`

// TYPES
interface FooterProps {
    column1?: React.ReactNode
    column2?: React.ReactNode
    column3?: React.ReactNode
}